(function() {
    'use strict';

    angular
        .module('liverunApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('racer', {
            parent: 'entity',
            url: '/racer',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.racer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/racer/racers.html',
                    controller: 'RacerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('racer');
                    $translatePartialLoader.addPart('racerType');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('racer-detail', {
            parent: 'racer',
            url: '/racer/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'liverunApp.racer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/racer/racer-detail.html',
                    controller: 'RacerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('racer');
                    $translatePartialLoader.addPart('racerType');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Racer', function($stateParams, Racer) {
                    return Racer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'racer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('racer-detail.edit', {
            parent: 'racer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/racer/racer-dialog.html',
                    controller: 'RacerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Racer', function(Racer) {
                            return Racer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('racer.new', {
            parent: 'racer',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/racer/racer-dialog.html',
                    controller: 'RacerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                description: null,
                                date: null,
                                startDate: null,
                                finishDate: null,
                                type: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('racer', null, { reload: 'racer' });
                }, function() {
                    $state.go('racer');
                });
            }]
        })
        .state('racer.edit', {
            parent: 'racer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/racer/racer-dialog.html',
                    controller: 'RacerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Racer', function(Racer) {
                            return Racer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('racer', null, { reload: 'racer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('racer.delete', {
            parent: 'racer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/racer/racer-delete-dialog.html',
                    controller: 'RacerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Racer', function(Racer) {
                            return Racer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('racer', null, { reload: 'racer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
